<template>
  <base-template>
    <slot />
  </base-template>
</template>

<script>
// @ is an alias to /src
import BaseTemplate from '@/components/templates/BaseTemplate.vue'

export default {
  name: 'CentralizedTemplate',
  components: {
    BaseTemplate
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: rgba(var(--bs-success-rgb));
}
</style>
